module.exports = __webpack_public_path__ + "static/media/rece-pl3.1d44d2c0.png";